import {useEffect, useMemo, useState} from "react";

import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {takeOfferListingAmplitudePendingDetailContext} from "../helpers/offer_listing_amplitude_item_list_id";

interface IParams {
    itemId?: number | null;
    propertyId?: number | null;
}

interface IState {
    itemListContext: IAmplitudeItemListContext | null;
    resolvedItemKey: string | null;
}

export const useOfferListingAmplitudePendingDetailItemListContext = (params: IParams) => {
    const {itemId, propertyId} = params;
    const itemKey = useMemo(() => (itemId == null ? null : `${itemId}:${propertyId ?? ""}`), [itemId, propertyId]);
    const [state, setState] = useState<IState>({
        itemListContext: null,
        resolvedItemKey: null
    });

    useEffect(() => {
        if (itemId == null || itemKey == null) {
            setState((currentState) =>
                currentState.resolvedItemKey === null
                    ? currentState
                    : {
                          itemListContext: null,
                          resolvedItemKey: null
                      }
            );
            return;
        }

        if (state.resolvedItemKey === itemKey) {
            return;
        }

        setState({
            itemListContext: takeOfferListingAmplitudePendingDetailContext({
                itemId,
                propertyId
            }),
            resolvedItemKey: itemKey
        });
    }, [itemId, itemKey, propertyId, state.resolvedItemKey]);

    return {
        itemListContext: state.resolvedItemKey === itemKey ? state.itemListContext : null,
        isResolved: itemKey != null && state.resolvedItemKey === itemKey
    };
};
import {useEffect, useMemo, useState} from "react";

import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {takeOfferListingAmplitudePendingDetailContext} from "../helpers/offer_listing_amplitude_item_list_id";

interface IParams {
    itemId?: number | null;
    propertyId?: number | null;
}

interface IState {
    itemListContext: IAmplitudeItemListContext | null;
    resolvedItemKey: string | null;
}

export const useOfferListingAmplitudePendingDetailItemListContext = (params: IParams) => {
    const {itemId, propertyId} = params;
    const itemKey = useMemo(() => (itemId == null ? null : `${itemId}:${propertyId ?? ""}`), [itemId, propertyId]);
    const [state, setState] = useState<IState>({
        itemListContext: null,
        resolvedItemKey: null
    });

    useEffect(() => {
        if (itemId == null || itemKey == null) {
            setState((currentState) =>
                currentState.resolvedItemKey === null
                    ? currentState
                    : {
                          itemListContext: null,
                          resolvedItemKey: null
                      }
            );
            return;
        }

        if (state.resolvedItemKey === itemKey) {
            return;
        }

        setState({
            itemListContext: takeOfferListingAmplitudePendingDetailContext({
                itemId,
                propertyId
            }),
            resolvedItemKey: itemKey
        });
    }, [itemId, itemKey, propertyId, state.resolvedItemKey]);

    return {
        itemListContext: state.resolvedItemKey === itemKey ? state.itemListContext : null,
        isResolved: itemKey != null && state.resolvedItemKey === itemKey
    };
};
